<template>
  <div class="home">
    <van-tabs @click='changIndex' v-model="tabIndex" animated>            
      <van-tab  title="阀门">
          <valvePage :nodeType='farmNodeInfo.nodeType' :login='farmNodeInfo.is_login' :uuid='farmNodeInfo.uuid' :baseName="farmNodeInfo.name" v-if="firstPage" @rListSon='rListSon'></valvePage>
      </van-tab>      
      <van-tab   title="地块" >
          <map-page :uuid='farmNodeInfo.uuid' :baseName="farmNodeInfo.name" v-if="tabIndex == 1 ? true:false" @rListSon='rListSon'></map-page>
      </van-tab>
      <van-tab  title="轮灌组">
        <rotationPage  :nodeType='farmNodeInfo.nodeType' :uuid='farmNodeInfo.uuid' :baseName="farmNodeInfo.name" v-if="tabIndex == 2 ? true:false" @rListSon='rListSon'></rotationPage>
      </van-tab>
      <van-tab  title="监控">
       <cameraPage :uuid='farmNodeInfo.uuid' :baseName="farmNodeInfo.name" v-if="tabIndex == 3 ? true:false" @rListSon='rListSon'></cameraPage>
      </van-tab>
      <van-tab  title="气象">
        <weatherPage :uuid='farmNodeInfo.uuid' :baseName="farmNodeInfo.name" v-if="tabIndex == 4 ? true:false" @rListSon='rListSon'></weatherPage>
      </van-tab>
      <van-tab  title="土壤">
        <soilPage :uuid='farmNodeInfo.uuid' :baseName="farmNodeInfo.name" v-if="tabIndex == 5 ? true:false" @rListSon='rListSon'></soilPage>
      </van-tab>
    </van-tabs> 

    <van-popup closeable  v-model="rListShow"  position="right" get-container="body"  :style="{ height: '100%',width:'80%' }">
        <div  style='height:65%;'>
        <van-cell-group title="基地列表">
          <van-search placeholder="请输入搜索关键词" @input='searchNode' v-model="searchText" />                        
        </van-cell-group>
        <div style='height:75%;overflow:auto'>
          <van-cell v-show="searchNodeList.length > 0 ? true : false"  @click="changNode(item)"   v-for="(item,index) in searchNodeList" :key="index"    :title="item.name"  >  
              <div v-if="item.name !=''" slot='default' :style="{color:item.is_login == 0?'#ee0a24':'#07c160'}">{{item.is_login == 0 ? '离线':'在线'}}</div>              
          </van-cell>
          <van-cell v-show="searchNodeList.length > 0 ? false : true">暂无该基地</van-cell>          
        </div>
      </div>
      <div v-show='tabIndex == 1 ?true:false'>
        <van-cell-group  title="图标筛选">
          <van-checkbox-group v-model="iconShowList">          
            <van-checkbox style='padding:5px' shape='square' v-for="(item, index) in 3" :key="index" :name="item">
              复选框 {{ item }}
            </van-checkbox>
          </van-checkbox-group>
        </van-cell-group>      
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src

import {getBaseList,getNodePointHome,getNodeValvePoint,getNodeCamera } from '@/request/data'
import valvePage from './valve.vue'
import cameraPage from './camera.vue'
import weatherPage from './weather.vue'
import rotationPage from './rotation.vue'
import soilPage from './soil.vue'
import mapPage from './map.vue'
import { mapState,mapMutations } from 'vuex'
export default {
  name: 'farm',
  components: {
    valvePage,
    cameraPage,
    weatherPage,
    rotationPage,
    mapPage,
    soilPage
  },
  data() {
    return {
      clientHeight:662,
      firstPage:true,
      nodeInfo:{
        nodeUuid:'',
        coordinate:'',
        isLogin:'',
        nodeType:''
      },
      rListShow:false,
      nodeName:'',
      nodeList:[],
      searchNodeList:[],
      searchText:'',      
      isShowPopup:false,
      tabIndex:0,
      pageIndex:0,
      valvedata:[],
      iconShowList:[],
    }
  },
  mounted() {
    if (this.token) {
      this.getNodeList()
    }
    if(this.isBack){
      this.tabIndex = this.backIndex
    }


  },  
  computed: {
    ...mapState(['phonePosition','token','farmNodeNameState','farmNodeInfo','isBack','backIndex'])
  },
  methods: {
    ...mapMutations(['setFarmNodeNameState','setFarmNodeInfo','setIsBack','setBackIndex']),
    getNodeList(){
      getBaseList().then(res=>{
        this.nodeList = res.data.data.node
        this.searchNodeList = res.data.data.node
        let isLogin
        if (res.data.data.node[0].is_login) {
          isLogin ='在线'
        }else{
          isLogin ='离线'
        }
        if (this.farmNodeNameState) {         
          this.nodeName = res.data.data.node[0].name
          this.nodeInfo.nodeUuid = res.data.data.node[0].uuid
          this.nodeInfo.coordinate = res.data.data.node[0].coordinate
          this.nodeInfo.isLogin = res.data.data.node[0].is_login
          this.nodeInfo.nodeType = res.data.data.node[0].node_type
          console.log(this.farmNodeInfo)
          let data = {}
          data.name = res.data.data.node[0].name
          data.uuid = res.data.data.node[0].uuid
          data.coordinate = res.data.data.node[0].coordinate
          data.is_login = res.data.data.node[0].is_login
          data.nodeType = res.data.data.node[0].node_type
          console.log(data)
          this.setFarmNodeNameState(false)
          this.setFarmNodeInfo(data)          
        }       
        
        
      })
      
    },
    changIndex(index){
      this.tabIndex = index
      if (index == 0) {
        this.firstPage = true
      }
    },
    changNodePopup(){//选择基地列表弹出
      this.searchNodeList = this.nodeList
      this.searchText = ''
      this.rListShow = true
    },
    changNode(item){        
        this.tabIndex = 0
        this.rListShow = false
        this.nodeName = item.name
        this.nodeInfo.nodeUuid = item.uuid
        this.nodeInfo.coordinate = item.coordinate
        this.nodeInfo.isLogin = item.is_login
        this.nodeInfo.nodeType = item.node_type
        let data = {}
        data.name = item.name
        data.uuid = item.uuid
        data.coordinate = item.coordinate
        data.is_login = item.is_login
        data.nodeType = item.node_type
        this.setFarmNodeInfo(data)
        if (this.pageIndex == 0) {
          
            this.firstPage = false
            setTimeout(() => {
              this.firstPage = true
              this.tabIndex = 0
            }, 100);
        }else{
          
          this.firstPage = false
          setTimeout(() => {
            this.tabIndex = this.pageIndex
          }, 1);
        }
    },
    searchNode(value){//搜索基地
        if (value == '') {
          this.searchNodeList = this.nodeList
        }else{
          this.searchNodeList = []          
          for (let i = 0; i < this.nodeList.length; i++) {
            if (this.nodeList[i].name.indexOf(value) >= 0) {
                this.searchNodeList.push(this.nodeList[i])
            }else{
                
            }
          }
        }
    },        
    rListSon(i){//子页面传值回来        
        if (i==0) {
          this.pageIndex = 6
          setTimeout(() => {
            this.pageIndex = 0
          }, 1);
          this.changNodePopup()
        }else{
          this.pageIndex = i
          this.changNodePopup()
        }
        
      
        
    },
    
  },
}
</script>


<style scoped>

</style>